import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import _ from 'lodash';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link, TextField } from '@material-ui/core';
import moment from 'moment-timezone';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import GroupTable from '../organisms/GroupTable';
import GroupEdit from '../organisms/GroupEdit';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGroups,
  getGroupDetail,
  downloadGroupInfo,
  DOWNLOAD_GROUP_INFO_SUCCESS,
  updateGroupSettingGochiKidUnlimit,
  UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS
} from '../../actions/Groups';
import { getShops } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import GroupRegisterButton from '../../components/atoms/GroupRegisterButton';
import GroupAddAdmin from '../organisms/GroupAddAdmin';
import SearchButton from '../../components/atoms/SearchButton';
import GroupListTable from '../organisms/GroupListTable';
import CommonButton from '../../components/atoms/CommonButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
import {
  GET_BANK_BRANCH_LIST_SUCCESS,
  GET_BANK_LIST_SUCCESS,
  getBankList,
  getBankBranchList
} from '../../actions/Bank';
import GochiKidUnlimitModalGroup from '../../components/molecules/GochiKidUnlimitModalGroup';
import GochiKidReceiptModalGroup from '../../components/molecules/GochiKidReceiptModalGroup ';
import {
  settingGochiKidReceiptGroup,
  SETTING_GOCHI_KID_RECEIPT_GROUP_SUCCESS
} from '../../actions/GochiKidReceipt';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  topButtonDiv: {
    padding: '10px 26px 10px 26px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  noteDiv: {
    padding: '10px 26px 10px 26px'
  },
  buttonGroupLeft: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 'auto'
  },
  groupName: {
    marginLeft: '15px'
  },
  buttonGroupRight: {
    display: 'flex',
    marginLeft: 'auto'
  },
  bottomButtonDiv: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right'
  },
  button: {
    margin: '5px 5px',
    minWidth: '140px',
    fontSize: '0.8rem'
  },
  textField: {
    marginLeft: '10px',
    padding: '0px 5px 0px 5px',
    width: '300px',
    zIndex: 5
  },
  backButton: {
    margin: 26
  },
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroups,
          getGroupDetail,
          getShops,
          getAccounts,
          downloadGroupInfo,
          getBankList,
          getBankBranchList,
          updateGroupSettingGochiKidUnlimit,
          settingGochiKidReceiptGroup
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('targetGroupId', 'setTargetGroupId', props => {
    return queryString.parse(props.location.search).groupId || 0;
  }),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('city', 'setCity', ''),
  withState('cityId', 'setCityId', ''),
  withState('groupIdentity', 'setGroupIdentity', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('openGroupAdd', 'updateOpenGroupAdd', false),
  withState('openGroupAddConfirm', 'updateOpenGroupAddConfirm', false),
  withState('groupNameKey', 'setGroupNameKey', ''),
  withState('groupIdKey', 'setGroupIdKey', ''),
  withState('addressKey', 'setAddressKey', ''),
  withState('detail', 'setDetail', {}),
  withState('listBank', 'setListBank', []),
  withState('listBankBranch', 'setListBankBranch', []),
  withState('groupChoice', 'setGroupChoice', null),
  withState(
    'openSettingUnlimitGochiKidModal',
    'updateOpenSettingUnlimitGochiKidModal',
    false
  ),
  withState(
    'openSettingGochiKidReceiptModal',
    'updateOpenSettingGochiKidReceiptModal',
    false
  ),
  withState('openProgressV2', 'updateOpenProgressV2', false),
  withState('loadingV2', 'updateLoadingV2', false),

  withHandlers({
    getGroupData: props => groupSearchKey => {
      const params = {
        ...groupSearchKey,
        groupId: props.targetGroupId
      };
      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions.getShops(params).then(shopData => {
        if (shopData.type === 'GET_SHOPS_SUCCESS') {
          props.updateOpenTable(true);
          props.updateOpenProgress(false);
        } else {
          props.setResultMessage('システムエラーが発生しました。');
        }
        props.updateLoading(false);
      });
    }
  }),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => async (event, page, limit, searchGroups) => {
      console.log('HANDLE CHANGE PAGE: ', page, limit);
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const groupSearchKey = {
        groupId: props.groupIdKey,
        groupName: props.groupNameKey,
        address: props.addressKey,
        limit,
        page
      };

      if (props.openTable && !searchGroups) {
        props.getGroupData(groupSearchKey);
      } else {
        props.updateLoading(true);
        props.updateOpenProgress(true);
        props.actions.getGroups(groupSearchKey).then(groupData => {
          if (groupData.error === true && groupData.payload.status === 403) {
            sendLogin(props);
          }
          if (groupData.type === 'GET_GROUPS_SUCCESS') {
            props.updateOpenProgress(false);
          } else {
            props.setResultMessage('システムエラーが発生しました。');
          }
          props.updateLoading(false);
          props.updateOpenProgress(false);
        });
      }
      // }
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.handleChangePage(
          null,
          this.props.page,
          this.props.rowsPerPage
        );
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    groups,
    checkSession,
    handleChangePage,
    handleRedirect,
    updateOpenTable,
    targetGroupId,
    setTargetGroupId,
    groupId,
    setGroupId,
    setGroupName,
    cityId,
    setCityId,
    openDrawer,
    updateOpenDrawer,
    openTable,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    groupIdentity,
    setGroupIdentity,
    page,
    setPage,
    openGroupAdd,
    updateOpenGroupAdd,
    openGroupAddConfirm,
    updateOpenGroupAddConfirm,
    updateGroups,
    groupIdKey,
    setGroupIdKey,
    groupNameKey,
    setGroupNameKey,
    addressKey,
    setAddressKey,
    rowsPerPage,
    setRowsPerPage,
    resultMessage,
    setOpenProgress,
    setResultMessage,
    setLoading,
    detail,
    setDetail,
    listBank,
    setListBank,
    listBankBranch,
    setListBankBranch,
    groupChoice,
    setGroupChoice,
    openSettingUnlimitGochiKidModal,
    updateOpenSettingUnlimitGochiKidModal,
    openSettingGochiKidReceiptModal,
    updateOpenSettingGochiKidReceiptModal,
    loadingV2,
    updateLoadingV2,
    openProgressV2,
    updateOpenProgressV2
  }) => {
    const processV2 = {
      loadingV2,
      updateLoadingV2,
      openProgressV2,
      updateOpenProgressV2,
      resultMessage,
      setResultMessage
    };

    const progressOkAction = () => {
      setOpenProgress(false);
      setResultMessage('');
      setLoading(false);
    };

    const progressOkActionV2 = () => {
      handleChangePage(null, page, rowsPerPage);
      updateOpenProgressV2(false);
      setResultMessage('');
      updateLoadingV2(false);
    };

    const searchKey = {
      groupId: groupIdKey,
      groupName: groupNameKey,
      address: addressKey,
      limit: rowsPerPage,
      page
    };

    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();
        linkEl.parentNode.removeChild(linkEl);
        // iOSのクリックイベント対策
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .downloadGroupInfo(searchKey)
        .then(data => checkSession(data));
      if (response.type === DOWNLOAD_GROUP_INFO_SUCCESS) {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        downloadCsvBlob(response.payload, `${timeStamp}_group_info.csv`);
      } else {
        setResultMessage('店舗情報ダウンロードに失敗しました。');
        updateLoading(false);
      }
    };

    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const roles = {
      isGroup,
      isSecretariat
    };

    const groupSearchKey = {
      groupId: targetGroupId,
      limit: rowsPerPage,
      page
    };

    useEffect(() => {
      groupSearchKey.page = 1;
      setPage(1);
      updateOpenProgress(true);
      updateLoading(true);
      const getGroupData = async () => {
        if (!targetGroupId) {
          updateOpenTable(false);
          setGroupId(0);
          setGroupName('');
          setGroupIdentity(false);
        } else {
          await actions.getGroupDetail(targetGroupId).then(data => {
            checkSession(data);
            setGroupId(data.payload.groupId);
            setGroupName(data.payload.groupName);
            setGroupIdentity(data.payload.groupAccountStatus.identity);
            actions.getShops(groupSearchKey).then(shopData => {
              if (shopData.type === 'GET_SHOPS_SUCCESS') {
                updateOpenTable(true);
              }
            });
            updateOpenProgress(false);
            updateLoading(false);
          });
        }
      };
      getGroupData();
    }, [targetGroupId]);

    const getGroup = async id => {
      await actions.getGroupDetail(id).then(detailData => {
        checkSession(detailData);
        const dataDetail = _.cloneDeep(detailData.payload);
        dataDetail.groupContactName = detailData.payload.groupContactName
          ? detailData.payload.groupContactName
          : '';
        dataDetail.department = detailData.payload.department
          ? detailData.payload.department
          : '';
        dataDetail.directPhone = detailData.payload.directPhone
          ? detailData.payload.directPhone
          : '';
        if (
          typeof detailData.payload.groupImages !== 'undefined' &&
          detailData.payload.groupImages !== null
        ) {
          dataDetail.images = detailData.payload.groupImages;
        } else {
          dataDetail.images = [];
        }
        dataDetail.cityId = detailData.payload.cityId
          ? detailData.payload.cityId
          : '';
        setDetail(dataDetail);
        setCityId(detailData.payload.cityId);
      });
    };

    const handleChangePageAction = () => {
      handleChangePage(null, page, rowsPerPage);
    };

    const getListBank = async () => {
      const bankResponse = await actions
        .getBankList()
        .then(data => checkSession(data));
      if (bankResponse.type === GET_BANK_LIST_SUCCESS) {
        setListBank(bankResponse.payload);
      } else {
        setListBank([]);
      }
    };

    const getListBankBranch = async () => {
      const bankBranchResponse = await actions
        .getBankBranchList()
        .then(data => checkSession(data));
      if (bankBranchResponse.type === GET_BANK_BRANCH_LIST_SUCCESS) {
        setListBankBranch(bankBranchResponse.payload);
      } else {
        setListBankBranch([]);
      }
    };

    const editOpenAction = async id => {
      updateLoading(true);
      updateOpenProgress(true);
      await getListBank();
      await getListBankBranch();
      await getGroup(id)
        .then(() => {
          updateOpenProgress(false);
          updateLoading(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    };
    const registerOpenAction = () => updateOpenGroupAdd(true);
    const groupCancelAction = () => updateOpenGroupAdd(false);
    const groupBackAction = () => updateOpenGroupAddConfirm(false);
    const searchAction = () => {
      setTargetGroupId(null);
      handleChangePage(null, 1, rowsPerPage, true);
      updateOpenTable(false);
    };
    const openShopListTable = id => {
      console.log('GROUP ID: ', id);
      setTargetGroupId(id);
    };

    const handeOpenSettingUnlimitGochiKidModal = group => {
      setGroupChoice(group);
      updateOpenSettingUnlimitGochiKidModal(true);
    };

    const updateSettingUnlimitGochiKid = async () => {
      updateOpenProgressV2(true);
      updateLoadingV2(true);
      const params = {
        gochiKidUnlimit: groupChoice.gochiKidUnlimit === 1 ? 0 : 1
      };

      await actions
        .updateGroupSettingGochiKidUnlimit(groupChoice.groupId, params)
        .then(async data => {
          checkSession(data);
          if (data.type === UPDATE_GROUP_SETTING_GOCHI_KID_UNLIMIT_SUCCESS) {
            updateOpenSettingUnlimitGochiKidModal(false);
            updateOpenProgressV2(true);
            setResultMessage('設定更新を完了しました。');
            updateLoadingV2(false);
          } else {
            setResultMessage('エラーが発生しました。');
            updateOpenProgressV2(false);
            updateLoadingV2(false);
          }
        });
    };

    const handeOpenSettingGochiKidReceiptModal = group => {
      setGroupChoice(group);
      updateOpenSettingGochiKidReceiptModal(true);
    };

    const updateSettingGochiKidReceipt = async () => {
      updateOpenProgressV2(true);
      updateLoadingV2(true);
      const params = {
        groupId: groupChoice.groupId,
        gochiKidReceipt: groupChoice.gochiKidReceipt === 1 ? 0 : 1
      };

      await actions.settingGochiKidReceiptGroup(params).then(async data => {
        checkSession(data);
        if (data.type === SETTING_GOCHI_KID_RECEIPT_GROUP_SUCCESS) {
          updateOpenSettingGochiKidReceiptModal(false);
          updateOpenProgressV2(true);
          setResultMessage('設定更新を完了しました。');
          updateLoadingV2(false);
        } else {
          setResultMessage('エラーが発生しました。');
          updateOpenProgressV2(false);
          updateLoadingV2(false);
        }
      });
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            グループ情報管理
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.topButtonDiv}>
            <TextField
              label="グループID"
              placeholder="部分一致"
              type="search"
              className={classes.textField}
              margin="normal"
              value={groupIdKey}
              onChange={e => {
                const value = e.target.value.replace(/[^\d]/, '');
                setGroupIdKey(value);
              }}
              inputProps={{ maxLength: 12 }}
            />
            <TextField
              label="運営会社名"
              placeholder="部分一致"
              type="search"
              className={classes.textField}
              margin="normal"
              value={groupNameKey}
              onChange={e => {
                setGroupNameKey(e.target.value);
                // setSearchSortKey('abc');
              }}
            />

            <TextField
              label="住所"
              placeholder="部分一致"
              type="search"
              className={classes.textField}
              margin="normal"
              value={addressKey}
              onChange={e => {
                setAddressKey(e.target.value);
                // setSearchSortKey('abc');
              }}
            />

            {/* <div className={classes.buttonGroupLeft}>
              <Button
                variant="contained"
                color="primary"
                disabled={!groupId}
                onClick={editOpenAction}
                className={classes.button}
              >
                グループ情報
                <br />
                編集
              </Button>
              {isGroup && (
                <Typography
                  component="p"
                  variant="h6"
                  color="textSecondary"
                  className={classes.groupName}
                >
                  {groupName}
                </Typography>
              )}
              {isSecretariat && (targetGroupId || targetGroupId === 0) && (
                <ReactSelectMaterialUi
                  required
                  label="グループ名"
                  className={classes.textField}
                  defaultValue={String(targetGroupId)}
                  value={String(targetGroupId)}
                  options={getGroupOptions()}
                  margin="normal"
                  onChange={v => {
                    setTargetGroupId(Number(v));
                  }}
                  SelectProps={{
                    isClearable: true,
                    msgNoOptionsMatchFilter:
                      '名前が部分一致するグループがありません'
                  }}
                />
              )}
              {isSecretariat && (targetGroupId || targetGroupId === 0) && (
                <ReactSelectMaterialUi
                  required
                  label="グループID"
                  className={classes.textField}
                  defaultValue={String(targetGroupId)}
                  value={String(targetGroupId)}
                  options={getGroupIdOptions()}
                  margin="normal"
                  onChange={v => {
                    setTargetGroupId(Number(v));
                  }}
                  SelectProps={{
                    isClearable: true,
                    msgNoOptionsMatchFilter:
                      '名前が部分一致するグループがありません'
                  }}
                />
              )}
            </div> */}
            <div>
              <SearchButton onClickAction={searchAction} />
            </div>

            {/* 上部右側のボタン 仮実装 */}
            <div className={classes.buttonGroupRight}>
              {isSecretariat && (
                <GroupRegisterButton onClickAction={registerOpenAction} />
              )}
              <Button
                variant="contained"
                color="primary"
                disabled={!groupIdentity}
                onClick={() => {
                  handleRedirect('/group_shops');
                }}
                className={classes.button}
              >
                グループ店舗
                <br />
                追加
              </Button>
              <CsvDownloadButton onClickAction={csvDownloadAction} />
            </div>
          </div>
          <div className={classes.noteDiv}>
            下記の設定をAI&Tさんへ redmine で依頼してください。
            <br />
            ①1000以上の店舗の開店状況を変更する（
            <Link
              href="https://redmine.1steam.com:8443/issues/128993"
              target="_blank"
              rel="noreferrer"
            >
              参考Redmineチケット
            </Link>
            ）
            <br />
            ②1000以上の店舗をグループから外す（
            <Link
              href="https://redmine.1steam.com:8443/issues/128847"
              target="_blank"
              rel="noreferrer"
            >
              参考Redmineチケット
            </Link>
            ）
          </div>
          {openTable && (
            <div className={classes.buttonGroupLeft}>
              <div className={classes.backButton}>
                <CommonButton
                  title="グループ一覧に戻る"
                  onClickAction={searchAction}
                />
              </div>
            </div>
          )}
          {openTable && (
            <GroupTable
              roles={roles}
              groupId={groupId}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
              setRowsPerPage={setRowsPerPage}
              rowsPerPage={rowsPerPage}
            />
          )}

          {!openTable && (
            <GroupListTable
              groups={groups}
              page={page}
              handleChangePage={handleChangePage}
              editOpenAction={editOpenAction}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              onOpenShopListTable={openShopListTable}
              handleChangePageAction={handleChangePageAction}
              handeOpenSettingUnlimitGochiKidModal={
                handeOpenSettingUnlimitGochiKidModal
              }
              handeOpenSettingGochiKidReceiptModal={
                handeOpenSettingGochiKidReceiptModal
              }
              processV2={processV2}
            />
          )}

          <div>
            <Modal open={openEditModal}>
              <GroupEdit
                updateOpenEditModal={updateOpenEditModal}
                openEditConfirm={openEditConfirm}
                updateOpenEditConfirm={updateOpenEditConfirm}
                editInput={detail}
                setDisplayGroupName={setGroupName}
                // cityId={cityId}
                // setCityId={setCityId}
                handleChangePage={handleChangePageAction}
                listBank={listBank}
                listBankBranch={listBankBranch}
              />
            </Modal>
          </div>
          <div>
            <Modal open={openGroupAdd}>
              <GroupAddAdmin
                openGroupAddConfirm={openGroupAddConfirm}
                updateOpenGroupAdd={updateOpenGroupAdd}
                updateOpenGroupAddConfirm={updateOpenGroupAddConfirm}
                cancelAction={groupCancelAction}
                backAction={groupBackAction}
                updateGroups={updateGroups}
                cityId={cityId}
                setCityId={setCityId}
              />
            </Modal>
          </div>

          <div>
            <Modal
              className={classes.modal}
              open={openSettingUnlimitGochiKidModal}
              onClose={() => {
                updateOpenSettingUnlimitGochiKidModal(false);
              }}
            >
              <GochiKidUnlimitModalGroup
                group={groupChoice}
                updateOpenSettingUnlimitGochiKidModal={
                  updateOpenSettingUnlimitGochiKidModal
                }
                updateSettingUnlimitGochiKid={updateSettingUnlimitGochiKid}
              />
            </Modal>
          </div>

          <div>
            <Modal
              className={classes.modal}
              open={openSettingGochiKidReceiptModal}
              onClose={() => {
                updateOpenSettingGochiKidReceiptModal(false);
              }}
            >
              <GochiKidReceiptModalGroup
                group={groupChoice}
                updateOpenSettingGochiKidReceiptModal={
                  updateOpenSettingGochiKidReceiptModal
                }
                updateSettingGochiKidReceipt={updateSettingGochiKidReceipt}
              />
            </Modal>
          </div>
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          loading={loading}
          resultMessage={resultMessage}
          progressOkAction={progressOkAction}
        />
        <ProgressDialog
          openProgress={openProgressV2}
          loading={loadingV2}
          resultMessage={resultMessage}
          progressOkAction={progressOkActionV2}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
